import React, { Component } from 'react'

import { connect } from 'react-redux'

import '../style/dids.scss'

//import StateSelector from './StateSelector'

import StatesInfo from '../store/reducers/statics/StatesInfo'

import TagsHolder from './TagsHolder'
import Tag from './Tag'
import Table from './Table'
import Checkbox from './Checkbox'
import DIDAddOns from './DIDAddOns'
import Alert from './Alert'
import Loader from './Loader'

import { setSearchTerm, performSearch, toggleDID } from '../store/actions/DIDsActions'

class DIDs extends Component {

    searchInputRef = React.createRef();
    state = {
        didAutoFill: false,
    }

    componentDidMount() {
        this.searchInputRef.focus();
    }

    setSearchTerm(value) {
        const { searchTerm } = this.props.data;
        this.searchInputRef.focus();
        this.props.setSearchTerm(value);
        if((searchTerm/*value*/ === "" || searchTerm/*value*/.toString().length <= 0) && this.state.didAutoFill) {
            this.setState({
                didAutoFill: false,
            })
        }
    }

    tagClicked(value) {
        this.props.setSearchTerm(value);
        this.props.performSearch(value);
        this.searchInputRef.focus();
    }

    onInputSubmit(e) {
        e.preventDefault();
        const { filters, filtersCount } = this.filterResults();
        //const { searchTerm } = this.props.data; //this.state;
        if(filtersCount > 0/* && filters[0].toLowerCase().startsWith(searchTerm.toLocaleLowerCase())*/) {
            this.tagClicked(filters[0]);
        }
    }

    filterResults() {
        const { searchTerm } = this.props.data;//this.state;
        var filters = [];
        searchTerm && Object.keys(StatesInfo).forEach(key => {
            const item = StatesInfo[key];
            if(item.state.trim().toLowerCase().startsWith(searchTerm.trim().toLowerCase()))
                filters.push(item.state);
            else if(item.stateAbrv.trim().toLowerCase().startsWith(searchTerm.trim().toLowerCase()))
                filters.push(item.stateAbrv);
            item.areaCodes.forEach(areaCode => {
                if(areaCode.trim().startsWith(searchTerm.trim())) {
                    filters.push(areaCode);
                }
            });
        })

        if(filters.length == 1 && isNaN(Number(filters[0]))) {
            if(searchTerm.toLowerCase() != filters[0].toLowerCase() && !this.state.didAutoFill) {
                this.setSearchTerm(filters[0]);
                this.setState({
                    didAutoFill: true,
                })
            }
            filters = this.getStateAreaCodes(filters[0]);
        }

        const filtersCount = filters.length;
        //filters = filters.slice(0, 10);
        return { filters, filtersCount }
    }

    getStateAreaCodes(firstResult) {
        return (StatesInfo.find(item => {
            return item.state == firstResult || item.stateAbrv == firstResult
        }).areaCodes)
    }

    toggleDID(DID) {
        this.props.toggleDID(DID);
        if(this.props.data.DIDsAdded.length <= 1 && this.props.isSelectedNumTableOpen) {
            this.props.toggleSelectedNums();
        }
    }

    didDIDAdded(DID) {
        const { DIDsAdded } = this.props.data;
        return DIDsAdded.find(item => item.DID == DID);
    }
    
    render() {
        const { searchTerm, results, DIDsAdded } = this.props.data;
        const { filters, filtersCount } = this.filterResults();
        const { isSelectedNumTableOpen } = this.props;
        
        const selectedDIDsTable = (
            <div className="table-holder" style={{margin: "2.5vh 0"}}>
                <div className="title">Numbers You Selected</div>
                <table>
                    <tbody>
                        <tr>
                            <th>Phone Numbers</th>
                            <th>SMS Eligible</th>
                            <th>Add To Cart</th>
                        </tr>
                    </tbody>
                    {
                        DIDsAdded.map((item, i) => {
                            const val = item.DID;
                            const didDIDAdded = this.didDIDAdded(val);
                            return (
                                [<tbody key={val}>
                                    <tr>
                                        <td>{val}</td>
                                        <td>
                                            <i className="fas fa-check"></i>
                                        </td>
                                        <td>
                                            <div style={{display: "flex", flexDirection: "row", 
                                                justifyContent: "center", alignItems: "center"}}>
                                                <span>${item.price}/month</span>
                                                <Checkbox
                                                    active={!!didDIDAdded} 
                                                    color="blue" style={{marginLeft: ".5rem"}}
                                                    onChange={() => {this.toggleDID(item.api)}} />
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>,
                                <DIDAddOns 
                                    isVisible={didDIDAdded}
                                    DID={val} 
                                    id={val + "-dropdown"} 
                                    key={val + "-dropdown"}
                                    toggles={didDIDAdded} />]
                            )
                        })
                    }
                </table>
            </div>
        );


        return (
            <div id="dids">
                {
                    isSelectedNumTableOpen && selectedDIDsTable
                }
                {/*<div id="did-options">
                    <div id="local-numbers">
                        <div>
                            <div className="title">Local Numbers</div>
                            <div>
                                <div className="sub-title">Choose State:</div>
                                <StateSelector />
                            </div>
                            <div>
                                <div className="sub-title">Area Code:</div>
                                <select defaultValue="SELECT">
                                    <option value="SELECT" disabled>Select</option>
                                    <option value="702">702</option>
                                    <option value="725">725</option>
                                    <option value="775">775</option>
                                </select>
                            </div>
                        </div>
                    </div>
                    <div id="toll-free-numbers">
                        <div>
                            <div className="title">Toll Free Numbers</div>
                            <div>
                                <div className="sub-title">Prefix:</div>
                                <select defaultValue="SELECT">
                                    <option value="SELECT" disabled>Select</option>
                                    <option value="8**">8**</option>
                                    <option value="800">800</option>
                                    <option value="844">844</option>
                                    <option value="855">855</option>
                                    <option value="866">866</option>
                                    <option value="877">877</option>
                                    <option value="888">888</option>
                                </select>
                            </div>
                        </div>
                    </div>
                </div>*/}

                <div id="search-dids">
                    <div className="title">
                        Search For Local or Toll Free Numbers
                    </div>
                        <div id="input-holder">
                            <form onSubmit={(e) => {
                                this.onInputSubmit(e)
                            }}>
                                <input
                                    ref={(input) => this.searchInputRef = input}
                                    onChange={(e) => {this.setSearchTerm(e.target.value)}} 
                                    value={searchTerm}
                                    placeholder='Enter a state, area code or 8**'
                                    />
                            </form>
                            <i 
                                onClick={() => this.setSearchTerm("")} 
                                className={"fas fa-times-circle " + (!searchTerm && " disabled")}></i>
                        </div>
                    <div>
                        <TagsHolder>
                            {
                                filters && filters.map((item, i) => {
                                    const startStr = item.slice(0, searchTerm.trim().length);
                                    const endStr = item.slice(searchTerm.trim().length, item.trim().length);
                                    return item && 
                                        <Tag 
                                            onClick={() => this.tagClicked(item)} 
                                            key={i}>{
                                                <span>
                                                    <span><b>{startStr}</b></span>
                                                    <span>{endStr}</span>
                                                </span>
                                            }</Tag>
                                })
                            }
                            {
                                /*filtersCount && filtersCount > 0 && (filtersCount - 10) > 0 ?
                                <Tag bold key={"i"}>+{filtersCount} More</Tag> : null*/
                            }
                        </TagsHolder>
                    </div>
                </div>

                {
                    (filtersCount <= 0 || searchTerm.length <= 0) && (
                        <div style={{textAlign: "center", margin: "0vh 5vw 5vh"}}>
                            <div className="title">
                                {searchTerm.length <= 0 ? "Search Phone Numbers" :
                                (filtersCount <= 0 && <span style={{color:"tomato"}}>Your Input is Invalid</span>)}
                            </div>
                            <div className="sub-title">
                                Enter a Local 3 Digit Area Code, a Toll Free Prefix or a State Name or Abbreviation
                            </div> 
                        </div> 
                    )
                }
                {
                    results.isLoading ? 
                    (<Loader />) 
                    :
                    (
                        results.error ? 
                        (<Alert type="DANGER" /*title="An Error Occurred"*/>
                            {results.errorMessage}
                        </Alert>)
                        :
                        (
                            results.dids && 
                            results.dids.length > 0 ? 
                            (<div id="did-numbers">
                                <div><i>* Routing, 411, E911 & CNAME setting are after login and purchase completed. More info below.</i></div>
                                <div><i>* Phone numbers are not secured until you complete the purchase.</i></div>
                                <table>
                                    <tbody>
                                        <tr>
                                            <th>Phone Numbers</th>
                                            {/*<th>411</th>
                                            <th>E911</th>
                                            <th>CName</th>*/}
                                            <th>SMS Eligible</th>
                                            {/*<th>Unlimited 1 to 1 SMS</th>*/}
                                            <th>Add To Cart</th>
                                        </tr>
                                    </tbody>
                                        {
                                            results.dids.map((item, i) => {
                                                const val = item.num;
                                                const didDIDAdded = this.didDIDAdded(val);
                                                return (
                                                    [<tbody key={val}>
                                                        <tr>
                                                            <td>{val}</td>
                                                            {/*<td>
                                                                <Checkbox />
                                                            </td>
                                                            <td>
                                                                <Checkbox />
                                                            </td>
                                                            <td>
                                                                <Checkbox />
                                                            </td>*/}
                                                            <td>
                                                                {
                                                                    item.smsok ?
                                                                    <i className="fas fa-check"></i>
                                                                    :
                                                                    <i className="fas fa-times"></i>
                                                                }
                                                            </td>
                                                            {/*<td>
                                                                <Checkbox />
                                                            </td>*/}
                                                            <td>
                                                                <div style={{display: "flex", flexDirection: "row", 
                                                                    justifyContent: "center", alignItems: "center"}}>
                                                                    <span>${item.price}/month</span>
                                                                    <Checkbox
                                                                        active={!!didDIDAdded} 
                                                                        color="blue" style={{marginLeft: ".5rem"}}
                                                                        onChange={() => {this.toggleDID(item)}} />
                                                                </div>
                                                            </td>
                                                        </tr>
                                                    </tbody>,
                                                    <DIDAddOns 
                                                        isVisible={didDIDAdded}
                                                        DID={val} 
                                                        id={val + "-dropdown"} 
                                                        key={val + "-dropdown"}
                                                        toggles={didDIDAdded} />]
                                                )
                                            })
                                        }
                                </table>
                                <div>
                                    <i>
                                        *411 Submission occur instantly, yet it is up to Directory Listing’ operators if to accept & when. Acceptance by Directories is not guaranteed and may require double verification of information provided. Fees are not refundable.
                                    </i>
                                    <br/>
                                    <i>
                                        *E911 is for emergency calls like 911 calls. A physical address is required. Calling 911 from a phone number without active E911 service, will cost $99 per call regardless your dialing plan.
                                    </i>
                                    <br/>
                                    <i>
                                        *CNAME is a caller ID services for incoming calls, when information is available. Some numbers do not list their CNAME data and therefore may not be available.
                                    </i>
                                </div>
                            </div>)
                            :
                            (
                                <div style={{textAlign: "center"}}>
                                    {/*<div className="title">
                                        Search For Toll Free Numbers
                                        <br/>
                                        or
                                        <br/>
                                        Local Numbers by State or Area Code
                                    </div>
                                    <div className="sub-title">
                                        For Example Type 'Nevada', 702 or 800
                                    </div>*/}
                                </div>
                            )
                        )
                    )
                }
            </div>
        )
    }
}



const mapStateToProps = (state) => {
    return {
        data: state.DIDsReducer
    }
}
const mapDispatchToProps = (dispatch) => {
    return {
        setSearchTerm: (value) => dispatch(setSearchTerm(value)),
        performSearch: (areaCode) => dispatch(performSearch(areaCode)),
        toggleDID: (DID) => dispatch(toggleDID(DID)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(DIDs);